/**
 * Spacing System - Consistent spacing values across the app.
 *
 * Base unit: 4px
 * Scale: 4, 8, 12, 16, 24, 32, 48, 64
 *
 * Usage:
 * - Use semantic names (buttonGap, cardPadding) when available
 * - Fall back to scale values (sm, md, lg) for general spacing
 * - Avoid arbitrary values; extend this file if needed
 */

/** Base spacing scale (in pixels) */
export const spacing = {
  /** 4px - Minimal spacing, tight elements */
  xs: 4,
  /** 8px - Small gaps, compact layouts */
  sm: 8,
  /** 12px - Medium-small, between xs and md */
  ms: 12,
  /** 16px - Standard spacing, comfortable layouts */
  md: 16,
  /** 24px - Large gaps, section separation */
  lg: 24,
  /** 32px - Extra large, major sections */
  xl: 32,
  /** 48px - Huge spacing, page-level separation */
  xxl: 48,
  /** 64px - Maximum spacing */
  xxxl: 64,
} as const;


